import useCollection from 'core/hooks/useCollection'

const useInteractions = (...args) => useCollection('interactions', ...args)
export default useInteractions
